export function jsDateFromAspDateString(aspDateString: string) {
  return new Date(Number(aspDateString.substring(6, aspDateString.length - 2)));
}
